import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';



// import { setModal } from '@cbwallet/NGRX/features/walletModal/walletModal.actions';
@Injectable()
export class MerchantEffects {
  // triggerSignIn = createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(triggerSignIn),
  //     exhaustMap((propVal) => {
  //
  //       return of(setModal({modalType: 'login'}));
  //     }))}, { dispatch: true});
  //
  // triggerRegistration = createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(triggerRegistration),
  //     exhaustMap((propVal) => {
  //
  //       return of(setModal({modalType: 'registration'}));
  //     }))}, { dispatch: true});

  constructor(
    private actions$: Actions
  ) {}
}


